import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';

import { loadAntDesignLocale, loadMomentLocale } from '@/config/locales';
import '@/config';

import store from '@/redux/store';

import emptyRender from '@/components/EmptyHint';
import CustomIconSymbol from '@/components/IconFont/customSymbol';
import DingTalkAuth from '@/pages/login/components/DingTalkAuth';
import { IntlContextWrapper } from '@/components/Intl/IntlContext';

import Login from '@/pages/login';
import Layout from '@/layout';
import NoAuth from '@/pages/NoAuth';
import NotFound from '@/pages/NotFound';
import About from '@/pages/About';
import Zoom from '@/pages/Zoom';

import './App.scss';

function App(props) {
  const [globalLocale, setGlobalLocale] = useState({} as any);

  useEffect(() => {
    loadAntDesignLocale(props.lang).then((data) => {
      setGlobalLocale(data);
    });
    loadMomentLocale(props.lang);
    document.documentElement.setAttribute('data-pms-lang', props.lang);
  }, [props.lang]);

  return (
    <Provider store={store}>
      <ConfigProvider locale={globalLocale} renderEmpty={emptyRender}>
        <IntlContextWrapper>
          <Router>
            <Switch>
              <Redirect exact from="/" to="/room-state/realtime" />
              <Route exact path="/login" component={Login} />
              <Route exact path="/about" component={About} />
              <Route exact path="/setting" component={Zoom} />
              <Route exact path="/authorization/ding-talk" component={DingTalkAuth} />
              <Route exact path="/401" component={NoAuth} />
              <Route path="/" component={Layout} />
              <Route path="*" component={NotFound} />
            </Switch>
          </Router>
        </IntlContextWrapper>
        <CustomIconSymbol />
      </ConfigProvider>
    </Provider>
  );
}

export default App;
